import React, { FC } from 'react';
import { Grid } from '@mui/material';

import {
  PendingFeesGrid,
  ExpenseCategoriesGrid,
  ScholarshipsGrid,
  BudgetVsActualGrid,
  FeeCollectionCharts,
  ExpenseChart,
} from './financialReports.grid';

// Combined Fee Collection Report Grid
export const FeeCollectionReportGrid: FC = () => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      <FeeCollectionCharts />
      <PendingFeesGrid />
    </Grid>
  );
};

// Combined Expense Report Grid
export const ExpenseReportGrid: FC = () => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      <ExpenseChart />
      <ExpenseCategoriesGrid />
    </Grid>
  );
};

// Combined Scholarship Report Grid
export const ScholarshipReportGrid: FC = () => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      <ScholarshipsGrid />
    </Grid>
  );
};

// Combined Budget vs Actual Report Grid
export const BudgetReportGrid: FC = () => {
  return (
    <Grid container spacing={{ xs: 2, sm: 3 }}>
      <BudgetVsActualGrid />
    </Grid>
  );
};
